import revive_payload_client_4sVQNw7RlN from "/build/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import vuetify_icons_KAumv2pUni from "/build/node_modules/vuetify-nuxt-module/dist/runtime/plugins/vuetify-icons.js";
import unhead_KgADcZ0jPj from "/build/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/build/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/build/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import _00_logger_client_605XsKn6aU from "/build/client/plugins/00.logger.client.ts";
import _01_axios_5xwLUIKhGf from "/build/client/plugins/01.axios.ts";
import payload_client_yVLowv6hDl from "/build/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/build/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/build/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/build/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/build/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/build/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_Ug908EZNww from "/build/node_modules/nuxt-site-config/dist/runtime/app/plugins/i18n.js";
import plugin_5drvKYmdqw from "/build/node_modules/@dargmuesli/nuxt-cookie-control/dist/runtime/plugin.mjs";
import plugin_Jozdw60ZsE from "/build/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import i18n_vciqEc2her from "/build/client/modules/i18n/runtime/plugins/i18n.ts";
import vuetify_no_client_hints_kyYn5AnnAK from "/build/node_modules/vuetify-nuxt-module/dist/runtime/plugins/vuetify-no-client-hints.js";
import _01_misc_ImW0RBW69T from "/build/client/plugins/01.misc.ts";
import _012_store_tIb91QiDRY from "/build/client/plugins/012.store.ts";
import _02_api_et5BGKO9cl from "/build/client/plugins/02.api.ts";
import _02_root_emitter_wHvq4TuA5R from "/build/client/plugins/02.root-emitter.ts";
import _022_auth_EEip8DDUQe from "/build/client/plugins/022.auth.ts";
import _023_tenant_JSNZtCg915 from "/build/client/plugins/023.tenant.ts";
import _04_globals_a3zjXhytfL from "/build/client/plugins/04.globals.ts";
import _10_snackbar_yhvYyOA9Jz from "/build/client/plugins/10.snackbar.ts";
import _14_subscription_kX6eicyvMZ from "/build/client/plugins/14.subscription.ts";
import _15_dialogs_Z3AKEVEjFr from "/build/client/plugins/15.dialogs.ts";
import _20_like_1jKTb7zIhb from "/build/client/plugins/20.like.ts";
import _50_gtm_5EAjZi610O from "/build/client/plugins/50.gtm.ts";
import _51_login_PvasY77Gfs from "/build/client/plugins/51.login.ts";
import _60_browser_storage_lRV0NLH9Lm from "/build/client/plugins/60.browser-storage.ts";
import _60_globalComponents_5iu9gqFByE from "/build/client/plugins/60.globalComponents.ts";
import _70_parentalControl_MM2KIorA1w from "/build/client/plugins/70.parentalControl.ts";
import _70_rating_a0VoEJKZu9 from "/build/client/plugins/70.rating.ts";
import _70_tournament_GovEBZxLxC from "/build/client/plugins/70.tournament.ts";
import apps_U4RYvZJM47 from "/build/client/plugins/apps.ts";
import arcade_TmVUlaMkgi from "/build/client/plugins/arcade.ts";
import cart_5t58ogSuBY from "/build/client/plugins/cart.ts";
import disclaimer_kiPrhRgeqY from "/build/client/plugins/disclaimer.ts";
import filters_yiWnKKeFkL from "/build/client/plugins/filters.ts";
import focus_reset_client_BVmbkifUNf from "/build/client/plugins/focus-reset.client.ts";
import games_kvjP7JdIVf from "/build/client/plugins/games.ts";
import gamification_I61pcGjSvG from "/build/client/plugins/gamification.ts";
import global_error_handling_17ywvatS1a from "/build/client/plugins/global-error-handling.ts";
import music_deEd37wA3r from "/build/client/plugins/music.ts";
import pwa_WDl7AkY8i7 from "/build/client/plugins/pwa.ts";
import redirection_client_zlcUxvnXen from "/build/client/plugins/redirection.client.ts";
import vee_validate_d7joHxS6QE from "/build/client/plugins/vee-validate.ts";
import vue_clipboard2_ZumkO15lmP from "/build/client/plugins/vue-clipboard2.ts";
import vuetify_nuxt_plugin_client_JOtFoHdxcp from "/build/.nuxt/vuetify-nuxt-plugin.client.mjs";
export default [
  revive_payload_client_4sVQNw7RlN,
  vuetify_icons_KAumv2pUni,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  _00_logger_client_605XsKn6aU,
  _01_axios_5xwLUIKhGf,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_Ug908EZNww,
  plugin_5drvKYmdqw,
  plugin_Jozdw60ZsE,
  i18n_vciqEc2her,
  vuetify_no_client_hints_kyYn5AnnAK,
  _01_misc_ImW0RBW69T,
  _012_store_tIb91QiDRY,
  _02_api_et5BGKO9cl,
  _02_root_emitter_wHvq4TuA5R,
  _022_auth_EEip8DDUQe,
  _023_tenant_JSNZtCg915,
  _04_globals_a3zjXhytfL,
  _10_snackbar_yhvYyOA9Jz,
  _14_subscription_kX6eicyvMZ,
  _15_dialogs_Z3AKEVEjFr,
  _20_like_1jKTb7zIhb,
  _50_gtm_5EAjZi610O,
  _51_login_PvasY77Gfs,
  _60_browser_storage_lRV0NLH9Lm,
  _60_globalComponents_5iu9gqFByE,
  _70_parentalControl_MM2KIorA1w,
  _70_rating_a0VoEJKZu9,
  _70_tournament_GovEBZxLxC,
  apps_U4RYvZJM47,
  arcade_TmVUlaMkgi,
  cart_5t58ogSuBY,
  disclaimer_kiPrhRgeqY,
  filters_yiWnKKeFkL,
  focus_reset_client_BVmbkifUNf,
  games_kvjP7JdIVf,
  gamification_I61pcGjSvG,
  global_error_handling_17ywvatS1a,
  music_deEd37wA3r,
  pwa_WDl7AkY8i7,
  redirection_client_zlcUxvnXen,
  vee_validate_d7joHxS6QE,
  vue_clipboard2_ZumkO15lmP,
  vuetify_nuxt_plugin_client_JOtFoHdxcp
]